<template>
  <div>
    <BaseFilter title="DAY RATE" :state="minimumDayRates">
      <template #default="{ data }">
        <b-form-checkbox-group
          v-model="selected"
          name="day-rate-filter"
          :options="parseDayRates(data)"
          value-field="id"
          stacked
          disabled-field="disabled"
        />
      </template>
    </BaseFilter>
  </div>
</template>

<script>
import { map, isEqual } from 'lodash/fp'
import localAsyncAction from '@/mixins/localAsyncAction'
import apiModules from '@/services'
import BaseFilter from '@/components/BaseFilter/BaseFilter'

export default {
  name: 'MinimumDayRateFilter',
  components: {
    BaseFilter
  },
  mixins: [
    localAsyncAction({
      key: 'minimumDayRates',
      initialState: [],
      fetcher: {
        methodName: 'fetchMinimumDayRates',
        handler: apiModules.fetchMinimumDayRates
      }
    })
  ],
  props: {
    value: {
      type: [Number, Array],
      default: () => []
    },
    filters: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      selected: this.value
    }
  },
  watch: {
    selected(value) {
      this.$emit('input', value)
    },
    filters: {
      handler(filters) {
        this.fetchMinimumDayRates(filters)
      },
      deep: true
    },
    value(value) {
      if (!isEqual(value, this.selected)) {
        this.selected = value
      }
    }
  },
  created() {
    this.fetchMinimumDayRates(this.filters)
  },
  methods: {
    parseDayRates(dayRates) {
      return map(
        dayRate => ({
          ...dayRate,
          text: dayRate.minimum_day_rate_description
        }),
        dayRates
      )
    }
  }
}
</script>
